/**
 * Extracts the WorkDrive resource ID from a WorkDrive URL or raw resource ID.
 * Example URL: "https://workdrive.zoho.com.au/folder/ltsu330deac83a5cd43e196dd279bd2c6062d"
 * Extracted ID: "ltsu330deac83a5cd43e196dd279bd2c6062d"
 */
export function extractWorkdriveResourceId(url?: string | null): string {
  if (!url) return "";
  const cleanUrl = url.split("?")[0].split("#")[0].replace(/\/+$/, "");
  const lastSegment = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1).trim();
  return lastSegment;
}





